import {RoleHeader} from "./RoleHeader";
import {RoleCell, VisibleRoleCell} from "./RoleCell";
import {VisibleCell, VisibleCellInfo} from "./VisibleCell";

export class RoleLines {

    private readonly role_lines: RoleLine[];

    constructor(role_lines: RoleLine[]) {
        this.role_lines = role_lines;
    }

    mapLines<U>(callbackfn: (RoleLine: RoleLine, index: number, array: RoleLine[]) => U): U[] {
        return this.role_lines.map(callbackfn);
    }

    getSelectedCellOrNull(): VisibleRoleCell | null {
        return this._findCell(c => c.State.IsSelected) ?? null;
    }

    private _findCell(predicate: (value: VisibleRoleCell, index: number, obj: VisibleRoleCell[]) => unknown) {
        let cell: VisibleRoleCell | undefined;
        this.role_lines.find(
            line => {
                cell = line.findCell(predicate);
                return cell !== undefined;
            }
        )
        return cell;
    }
}

export class RoleLine {
    public readonly header: RoleHeader;
    private readonly cells: VisibleRoleCell[];

    constructor(header: RoleHeader, cells: VisibleRoleCell[]) {
        this.header = header;
        this.cells = cells;
    }

    mapCells<U>(callbackfn: (cell: VisibleRoleCell, index: number, array: VisibleRoleCell[]) => U): U[] {
        return this.cells.map(callbackfn);
    }

    findCell(predicate: (value: VisibleRoleCell, index: number, obj: VisibleRoleCell[]) => unknown): VisibleRoleCell | undefined {
        return this.cells.find(predicate);
    }

    static makeVisibleCells(cells: RoleCell[], merge: boolean,
                            callckabfn: (v: VisibleCellInfo<RoleCell>) => VisibleRoleCell)
        : VisibleRoleCell[] {

        return VisibleCell.makeVisibleCellList(cells).filter(
            v => (!merge || 0 < v.keys.length)
        ).map(
            v => callckabfn(v)
        );
    }

}
